export default function (mortgage, config){
    return {
        sections: [
            {
                map: {},
                errors: []
            }
        ]
    }
}